import React, { useEffect, useMemo, useRef, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import * as Yup from "yup";
import { StyledButton } from "../../../../../shared/components/buttons/custom-button";
import FormBuilder from "../../../../../shared/components/form-builder/form-builder";
import ModalPopup from "../../../../../shared/components/modals/custom-popup";
import { ActionsMenu } from "../../../../../shared/components/table/custom-actions";
import CustomTable from "../../../../../shared/components/table/custom-table";
import { MRT_ColumnDef } from "material-react-table";
import {
  FloatingButtonContainer,
  FloatingContainer,
  InnerButton,
} from "../../../../../shared/components/buttons/floating-button-container";
import { dtrackItService } from "../../../tc-service/dtrackit.service";
import { transactionCertificateService } from "../../../tc-service/transaction-certificate.service";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import {
  IShipmentConsigneeDetail,
  mapToIShipmentConsigneeDetails,
  mapToShipmentConsigneeDetailJsonObject,
  shipmentsIntialValues,
} from "../../../tc-models/tc-req-dto/tc-shipments.req_dto";
import useNotification from "../../../../../shared/hooks/useNotification";
import { shipmentsDetailsService } from "../../../tc-service/shipments.service";
import { useFormActions } from "../../../../../shared/hooks/form-builder.hooks";
import { buyerSellerDetailsService } from "../../../tc-service/buyer-seller-details.service";
import {
  DELETECONFIG,
  TC_CREATE_ROUTE_CONFIG,
  TCAppConfig,
} from "../../../../../shared/app-configs/tc-app-configs";
import { useApi } from "../../../../../shared/hooks/useApi";
import { LoaderComponent } from "../../../../../shared/components/loaders/page-loader";
import AlertPopup from "../../../../../shared/components/modals/alert-moadal";
import { useTransactionCertificate } from "../../../../../shared/hooks/transaction-certificate.hooks";
import _ from "lodash";
import { useTransactionCertificateStore } from "../../../../../store/transaction-certificates.store";
import { Utills } from "../../../../../shared/app-configs/utilit";
import RenderDetailPanel from "./render-detail-panel";
import { ApiShipmentResponseItem } from "./shipments.model";
import { createPayload, fetchShipmentDetails } from "./shipment-api";
import { Pagination } from "../../../../../shared/hooks/useRecordStore";

//TODO Move Shipment to Model FOlder and rename it to IShipment
interface Shipment {
  tcShipmentNo: string;
  tcShipmentDate: string | null;
  tcShipmentDocNo: string;
  tcGrossShippingWeight: string;
  consigneeTeId: string;
  tcShipmentInvoiceReferences: string[];
  consigneeAddress1: string;
  consigneeAddress2: string;
  consigneeAddress3: string;
  consigneeTown: string;
  consigneePostcode: string;
  consigneeCountryOrArea: string;
  consigneeStateOrProvince: string;
  isConsigneeTeCertified: string;
  consigneeName?: string;
  tcShipmentConsigneeOrder?: string;
}
// tcShipmentConsigneeOrder: "",
interface ShipmentsProps {
  onNextTab: () => Promise<void>;
}

const Shipments: React.FC<ShipmentsProps> = ({ onNextTab }) => {
  const formRef = useRef<any>(null);
  const { notify } = useNotification();
  const [countries, setCountries] = useState([]);
  const [states, setState] = useState([]);
  const navigate = useNavigate();
  const [initialValues, setInitialValues] = useState<IShipmentConsigneeDetail>(
    shipmentsIntialValues.tcShipmentConsigneeDetails[0]
  );
  const [tableData, setTableData] = useState<ApiShipmentResponseItem[]>([]);
  const [data, setData] = useState<IShipmentConsigneeDetail[]>([]);
  const { TE_ID, formtype } = useParams<string>();
  const hasCreateTc: boolean = formtype === "create-tc";
  const hasSubmitTC: boolean = formtype === "submited-tc";
  const [getEditRowIndex, setEditRowIndex] = useState(-1);
  const {
    loading,
    error,
    executeGet,
    setLoadingState,
    executePost,
    executeDelete,
  } = useApi();
  const { loading: loadingAdditional, executeGet: executeAdditionalGet } =
    useApi();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [getCopy, setCopy] = useState(false);

  const [apiShipmentsData, setAPIShipmentsData] = useState<
    IShipmentConsigneeDetail[]
  >([]);
  const [pendingSave, setPendingSave] = useState<any | null>(null);
  const [originalValue, setOriginalValue] = useState("");
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [popUpTitle, setPopUpTitle] = useState<string>("");
  const [popUpBtnName, setPopUpBtnName] = useState<string>("");
  const {
    isDelayResonSet,
    tcIssueDate,
    setStates,
    setCountryCodes,
    getTCStandardGOTS,
    isAdmin,
    cbLicensingCode,
    originalAdminCBID,
  } = useTransactionCertificateStore();
  // Admin is view-only when viewing another CB; admin on their own CB gets full edit access
  const isViewOnly = isAdmin && cbLicensingCode !== originalAdminCBID;
  const [isNextEnabled, setNextEnabled] = useState<boolean>(false);
  const [apiData, setAPIData] = useState<IShipmentConsigneeDetail[]>([]);
  const [selectedShipmentId, setSelectedShipmentId] = useState<string | null>(
    null
  );
  const [tcShipmentNo, setTcShipmentNo] = useState<string | null>(null);
  const [getEditExistingShipment, setEditExistingShipment] = useState({
    index: -1,
    value: "",
  });
  const [isTEEnabled, setTEEnabled] = useState<boolean>(true);
  const [disable, setDisable] = useState({
    disableConsigneeCountryOrArea: true,
    disableConsigneeStateorProvince: true,
    disableConsigneePostCode: true,
    disableConsigneeTown: true,
    disableConsigneeAddress1: true,
  });
  const [pagination, setPagination] = useState<Pagination>({
        pageIndex: 0,
        pageSize: 10,
      });
  const [rowCount, setRowCount] = useState<number>(0);

  // TO DO Port Changes
  const handleConfirmSave = async () => {
    if (!selectedShipmentId) {
      notify("No shipment selected for deletion", "error");
      return;
    }
    let isSaveSuccess = false;
    try {
      if (pendingSave) {
        isSaveSuccess = await handleSaveData(
          pendingSave,
          pendingSave.shipmentId
        );
      }
      // Execute the delete API call, sending both TE_ID and the selected shipmentId
      if (!pendingSave || isSaveSuccess) {
        const res = await executeDelete(`${TCAppConfig.TC_DELETE_API}`, {
          pageName: DELETECONFIG.shipment,
          tcId: TE_ID,
          shipmentId: selectedShipmentId,
          shipmentNo: encodeURIComponent(
            encodeURIComponent(tcShipmentNo ?? "")
          ),
        });

        if (res?.status === 200) {
          if (pendingSave) {
            notify("Previous Shipment deleted successfully", "success");
          } else {
            notify("Shipment deleted successfully", "success");
          }

          // Check if we have data to save after deletion

          // else {
          loadFormData();
          // }
        }
      }
      // Optionally reload or update your data here
    } catch (error) {
      console.error("Error deleting shipment:", error);
      notify("Failed to delete shipment", "error");
    } finally {
      // Close the dialog and reset state
      setDialogOpen(false);
      setPendingSave(null);
      setSelectedShipmentId(null);
    }
  };
  // TO DO Port Changes
  const handleCancelSave = () => {
    setDialogOpen(false);
    if (drawerOpen) {
      toggleDrawer();
    }
    setCopy(false);
  };

  const {
    getCurrentFormValues,
    getCurrentTableData,
    updateTableData,
    updateField,
    updateTableRowbyIndex,
    removeTableRowbyIndex,
    setNewDataTCSaved,
    setEditSave,
    setDeleteSave,
    resetFormValueByPage,
    getDeleteSave,
    replaceTableDatas,
  } = useFormActions("shipments");
  const [isDeleteOnly, setDeleteOnly] = useState(false);

  const loadFormData = async () => {
    try {
      const response1: any = await executeGet(TCAppConfig.GET_SHIPMENTS_LIST, {
        tcId: TE_ID,
        limit:pagination?.pageSize,
        offset:pagination?.pageIndex*pagination?.pageSize
      });
      const result = response1.data;
      // alert(JSON.stringify(result));
      setRowCount(response1?.data?.no_of_records);
      setTableData(response1.data.response);
      setAPIData(response1);
      if (getCurrentTableData().length > 0) {
        replaceTableDatas(result);
      } else {
        updateTableData(result);
      }
      setNextEnabled(true);
      setAPIShipmentsData(result);
      setDeleteSave(false);
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };

  const setZustandInitialState = (initialState?: any) => {
    const defaultState = {
      tcId: "",
      tcGrossShippingWeight: "",
      tcShipmentConsigneeDetails: [
        {
          tcShipmentConsigneeOrder: "",
          tcShipmentNo: "",
          tcShipmentDate: "",
          tcShipmentDocNo: "",
          tcGrossShippingWeight: "",
          tcShipmentInvoiceReferences: [],
          consigneeName: "",
          consigneeTeId: "",
          consigneeAddress1: "",
          consigneeAddress2: "",
          consigneeAddress3: "",
          consigneePostcode: "",
          consigneeTown: "",
          consigneeStateOrProvince: "",
          consigneeCountryOrArea: "",
          isConsigneeTeCertified: "Y",
        },
      ],
    };
    console.log(`initialState from shipments ${initialState}`);
    Object.entries(initialState ?? defaultState).forEach(([key, value]) => {
      updateField(key, value);
    });
  };

  useEffect(() => {
    if (TE_ID) {
      loadFormData();
    } else {
      // TO DO Port Changes
      updateTableData([]);
    }
    // TO DO Port Changes
    resetFormValueByPage();
    setZustandInitialState(null);
  }, [pagination?.pageIndex]);

  // Handle form submission outside of FormBuilder
  const handleSubmit = async () => {
    if (formRef.current) {
      try {
        console.log("Selected Shipment ID:", selectedShipmentId);

        await formRef.current.submitForm(); // Wait for the form to be submitted
        Utills.cl("Form submitted successfully!");
      } catch (error) {
        console.error("Error during form submission:", error);
      }
    } else {
      console.error("formRef is null");
    }
  };

  useEffect(() => {
    const shipmentsTableDatas = getCurrentTableData();
    Utills.cl(`shipmentsTableDatas ${JSON.stringify(shipmentsTableDatas)}`);
    if (shipmentsTableDatas) {
      setData(shipmentsTableDatas);
    }
    const getCountry = async () => {
      try {
        const result: any = await dtrackItService.getCountry();
        Utills.cl(`getCountry result ${JSON.stringify(result)}`);
        const countries = result.data.map((t: any) => ({
          value: t.code_1,
          label: `${t.description_1} (${t.code_1})`,
        }));
        Utills.cl(`countries ${countries}`);
        setCountries(countries);
        setCountryCodes(countries);
        // Utills.cl(`getCountry ${countries}`)
      } catch (err) {
        Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
      }
    };

    getCountry();
  }, []);

  const getState = async (consigneeCountryOrArea: string) => {
    try {
      const result: any = await dtrackItService.getStateBasedonCountry(
        consigneeCountryOrArea
      );
      const states = result.data.map((t: any) => ({
        value: t.code_1,
        label: `${t.description_1} (${t.code_1})`,
      }));
      setState(states);
      setStates(states);
    } catch (err) {
      Utills.cl(`Error in Fetching Organic Farm Standard Code ${err}`);
    }
  };

  const resetForm = () => {
    setInitialValues({
      tcShipmentNo: "",
      tcShipmentDate: "",
      tcShipmentDocNo: "",
      tcGrossShippingWeight: "",
      consigneeTeId: "",
      tcShipmentInvoiceReferences: [],
      consigneeAddress1: "",
      consigneeAddress2: "",
      consigneeAddress3: "",
      consigneeTown: "",
      consigneePostcode: "",
      consigneeCountryOrArea: "",
      consigneeStateOrProvince: "",
      isConsigneeTeCertified: "Y",
      consigneeName: "",
    });
    // TO DO Port Changes
  };

  const [drawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawer = () => {
    setZustandInitialState();
    if (drawerOpen) {
      resetForm();
      setSelectedShipmentId(null);
      setPendingSave(null);
    }

    setDrawerOpen((prev) => !prev);
    // setCopy(false);
  };
  const fetchTEDetallsFromAPI = async (
    value: string,
    offset: number,
    type: string,
    name?: string
  ): Promise<any[]> => {
    try {
      const queryParams: Record<string, any> = {
        query_param: type == "query" ? value : "",
        offset: offset,
        name: type == "name" ? value : "",
      };
      // Fetch TE Details using the getTEDetails function
      const response = await buyerSellerDetailsService.getTEDetails(
        queryParams
      );
      const data = response.data;
      return data;
    } catch (error) {
      console.error("Error fetching TE details:", error);
      throw error; // Re-throw error to handle it in the calling code
    }
  };

  // Table column configuration
  const columns: MRT_ColumnDef<any>[] = [
    {
      accessorKey: "tcShipmentNo",
      header: "Shipment No.",
      enableHiding: false,
      minSize: 100,
      maxSize: 200,
    },
    {
      accessorKey: "tcShipmentDate",
      header: "Shipment Date",
      enableHiding: false,
      minSize: 100,
      maxSize: 200,
    },
    {
      accessorKey: "tcShipmentDocNo",
      header: "Shipment Doc No.",
      minSize: 100,
      maxSize: 200,
    },
    {
      accessorKey: "tcGrossShippingWeight",
      header: "Gross Shipping Weight (kg)", //renamed to match field name in Add Shipment
      minSize: 100,
      maxSize: 200,
      Cell: Utills.usNumberFormat,
    },
    {
      accessorKey: "consigneeTeId",
      header: "Consignee TE ID",
      minSize: 100,
      maxSize: 200,
    },
    {
      accessorKey: "tcShipmentInvoiceReferences",
      header: "Invoice Reference No.",
      minSize: 100,
      maxSize: 200,
      Cell: ({ cell }: { cell: any }) => {
        const invoiceRefArray: string[] | undefined = cell.getValue();
        return Array.isArray(invoiceRefArray)
          ? invoiceRefArray.join(", ")
          : invoiceRefArray;
      },
    },
  ];

  // TO DO Port Changes

  const handleConsigneeTEIdValueChange = async (value: any) => {
    const fields = [
      "consigneeName",
      "consigneeAddress1",
      "consigneeTown",
      "consigneePostcode",
      "consigneeCountryOrArea",
      "consigneeStateOrProvince",
      "consigneeTeId",
    ];
    if (value == null) {
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });
      setTEEnabled(true);
      setDisable((prev) => ({
        ...prev,
        disableConsigneeCountryOrArea: true,
        disableConsigneeStateorProvince: true,
        disableConsigneePostCode: true,
        disableConsigneeTown: true,
      }));
    } else {
      // alert(value.state);
      formRef.current.setFieldValue("consigneeTeId", value.TE_ID);
      formRef.current.setFieldValue("consigneeName", value.account_name);
      // formRef.current.setFieldValue("consigneeAddress1", value.street);
      // formRef.current.setFieldValue(
      //   "consigneePostcode",
      //   value.postal_code || ""
      // );
      // formRef.current.setFieldValue("consigneeCountryOrArea", value.country);
      // formRef.current.setFieldValue("consigneeStateOrProvince", value.state);
      setTEEnabled(false);

      //handle consignee address1
      if (value.street == null) {
        setDisable((prev) => ({
          ...prev,
          disableConsigneeAddress1: false,
        }));
        formRef.current.setFieldValue("consigneeAddress1", "");
      } else {
        setDisable((prev) => ({
          ...prev,
            disableConsigneeAddress1: true,
        }));
        formRef.current.setFieldValue("consigneeAddress1", value.street || "");
      }

      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          disableConsigneeTown: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          disableConsigneeTown: true,
        }));
        formRef.current.setFieldValue("consigneeTown", value.city || "");
      }

      if (value.country) {
        // alert(value.country);
        let countryCode = JSON.stringify(
          `[${[value.country].map((item) => `'${item}'`)}]`
        ).replace(/^"|"$/g, "");
        await getState(countryCode);
      }

      // if (value.city == null) {
      //   setDisable((prev) => ({
      //     ...prev,
      //     disableConsigneeTown: false,
      //   }));
      // } else {
      //   setDisable((prev) => ({
      //     ...prev,
      //     disableConsigneeTown: true,
      //   }));
      //   formRef.current.setFieldValue("consigneeTown", value.city || "");
      // }

      if (value.postal_code == null) {
        setDisable((prev) => ({
          ...prev,
          disableConsigneePostCode: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          disableConsigneePostCode: true,
        }));
        formRef.current.setFieldValue("consigneePostcode", value.postal_code);
      }

      if (value.country == null) {
        setDisable((prev) => ({
          ...prev,
          disableConsigneeCountryOrArea: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          disableConsigneeCountryOrArea: true,
        }));
        formRef.current.setFieldValue("consigneeCountryOrArea", value.country);
      }
      if (value.state == null) {
        setDisable((prev) => ({
          ...prev,
          disableConsigneeStateorProvince: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          disableConsigneeStateorProvince: true,
        }));
        formRef.current.setFieldValue("consigneeStateOrProvince", value.state);
      }
    }
  };

  const handleConsigneeNameValueChange = async (value: any) => {
    const fields = [
      "consigneeName",
      "consigneeAddress1",
      "consigneeTown",
      "consigneePostcode",
      "consigneeCountryOrArea",
      "consigneeStateOrProvince",
      "consigneeTeId",
    ];
    if (value == null) {
      fields.forEach((field) => {
        formRef.current.setFieldValue(field, "");
      });
      setTEEnabled(true);
      setDisable((prev) => ({
        ...prev,
        disableConsigneeCountryOrArea: true,
        disableConsigneeStateorProvince: true,
        disableConsigneePostCode: true,
        disableConsigneeTown: true,
      }));
    } else {
      formRef.current.setFieldValue("consigneeTeId", value.TE_ID);
      formRef.current.setFieldValue("consigneeName", value.account_name);
      // formRef.current.setFieldValue("consigneeAddress1", value.street);
      // formRef.current.setFieldValue(
      //   "consigneePostcode",
      //   value.postal_code || ""
      // );
      // formRef.current.setFieldValue("consigneeCountryOrArea", value.country);
      // formRef.current.setFieldValue("consigneeStateOrProvince", value.state);
      setTEEnabled(false);

      //handle consignee address1
      if (value.street == null) {
        setDisable((prev) => ({
          ...prev,
          disableConsigneeAddress1: false,
        }));
        formRef.current.setFieldValue("consigneeAddress1", "");
      } else {
        setDisable((prev) => ({
          ...prev,
          disableConsigneeAddress1: true,
        }));
        formRef.current.setFieldValue("consigneeAddress1", value.street || "");
      }

      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          disableConsigneeTown: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          disableConsigneeTown: true,
        }));
        formRef.current.setFieldValue("consigneeTown", value.city || "");
      }

      if (
        value.country != null &&
        value.country != "" &&
        value.country != undefined
      ) {
        let countryCode = JSON.stringify(
          `[${[value.country].map((item) => `'${item}'`)}]`
        ).replace(/^"|"$/g, "");

        await getState(countryCode);
      }

      if (value.city == null) {
        setDisable((prev) => ({
          ...prev,
          disableConsigneeTown: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          disableConsigneeTown: true,
        }));
        formRef.current.setFieldValue("consigneeTown", value.city || "");
      }

      if (value.postal_code == null) {
        setDisable((prev) => ({
          ...prev,
          disableConsigneePostCode: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          disableConsigneePostCode: true,
        }));
        formRef.current.setFieldValue("consigneePostcode", value.postal_code);
      }

      if (value.country == null) {
        setDisable((prev) => ({
          ...prev,
          disableConsigneeCountryOrArea: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          disableConsigneeCountryOrArea: true,
        }));
        formRef.current.setFieldValue("consigneeCountryOrArea", value.country);
      }
      if (value.state == null) {
        setDisable((prev) => ({
          ...prev,
          disableConsigneeStateorProvince: false,
        }));
      } else {
        setDisable((prev) => ({
          ...prev,
          disableConsigneeStateorProvince: true,
        }));
        formRef.current.setFieldValue("consigneeStateOrProvince", value.state);
      }
    }
  };

  // const onCountryChange = (value: string) => {
  //   Utills.cl(`onCountryChange ${JSON.stringify(value)}`);
  // };

  // const fetchConsigneeTEIdFromAPI = async (
  //   query: string,
  //   offset: number
  // ): Promise<string[]> => {
  //   // Simulated delay for API call
  //   return new Promise((resolve) => {
  //     setTimeout(() => {
  //       const results = Array.from(
  //         { length: 10 },
  //         (_, i) => `${query} Result ${offset + i + 1}`
  //       );
  //       resolve(results);
  //     }, 300);
  //   });
  // };
  // Form configuration for "Add Shipment" and "Edit Shipment"

  const shipmentConsigneeDetailValidationSchema = Yup.object().shape({
    tcShipmentNo: Yup.string()
      .when([], {
        is: () => !getTCStandardGOTS, // Only required if GOTS is NOT present
        then: Yup.string().required("Shipment Number is required"),
      })
      .max(40, "Maximum 40 Character is Allowed"), // Only required if GOTS is NOT present
    tcShipmentDate: Yup.date()
      .when([], {
        is: () => !getTCStandardGOTS,
        then: Yup.date().required("Shipment Date is required"),
      })
      .test(
        "shipment-date-before-issue-date",
        "Shipment date must be on or before the TC Issue Date in Transaction Details Tab",
        function (shipmentDate) {
          if (!tcIssueDate || !shipmentDate) return true;
          return new Date(shipmentDate) <= new Date(tcIssueDate);
        }
      )
      .test(
        "is-within-180-days",
        "Shipment date cannot be more than 180 days from today",
        function (value: any) {
          if (!isDelayResonSet && tcIssueDate) {
            const differenceInDays = Math.abs(
              Utills.calculateDateDifferenceInDays(tcIssueDate, value)
            );
            Utills.cl("Difference in days:", differenceInDays);
            if (differenceInDays >= 180) {
              return this.createError({
                message:
                  "Please Fill Delay Reason in Transaction Details Tab, if Shipment date is more than 180 days before issue date",
              });
            }
          }
          return true;
        }
      ),

    tcShipmentDocNo: Yup.string()
      .when([], {
        is: () => !getTCStandardGOTS,
        then: Yup.string()
          .matches(
            /^[^\s]+$/,
            "Shipment Doc No. cannot have white spaces"
          )
          .required("Shipment Document Number is required"),
      })
      .max(40, "Maximum 40 Character is Allowed"),

    tcShipmentGrossShippingWeight: Yup.string()
      .test(
        "is-exactly-two-decimal-places",
        "Number must be a valid decimal number with up to 2 decimal places.",
        (value: string | undefined) => {
          if (!value) return true; // Allow empty values if required is disabled
          return /^(0|[0-9]\d*|0\.\d{1,2}|[0-9]\d*\.\d{1,2})$/.test(value); // Match exactly two decimal places
        }
      )
      .when([], {
        is: () => !getTCStandardGOTS,
        then: Yup.string().required(
          "Shipment Gross Shipping Weight is required"
        ),
      })
      .typeError("Shipment Gross Shipping Weight must be a valid number"),

    tcShipmentInvoiceReferences: Yup.array()
      .test(
        "all-valid-invoice-refs",
        "Invoice Reference No. cannot have white spaces and can have upto 255 characters",
        (arr) => {
          if (!arr || arr.length === 0) return false; // Will be handled by min(1)
          // Only show one error if any chip is invalid
          return arr.every(
            (val) =>
              typeof val === "string" &&
              /^[^\s]+$/.test(val) &&
              val.length <= 255
          );
        }
      )
      .when([], {
        is: () => !getTCStandardGOTS,
        then: Yup.array().min(1, "At least one invoice reference is required"),
      }),
    consigneeName: Yup.string().nullable(),
    consigneeAddress1: Yup.string().nullable(),
    consigneeTown: Yup.string().nullable(),
    consigneeStateOrProvince: Yup.string().nullable(),
    consigneeCountryOrArea: Yup.string().nullable(),

    tcShipmentConsigneeOrder: Yup.string().nullable(), // Optional field
    consigneeTeId: Yup.string().nullable(),
    consigneeAddress2: Yup.string().nullable(), // Optional field
    consigneeAddress3: Yup.string().nullable(), // Optional field
    consigneePostcode: Yup.string().nullable(),
    ocsFirstProcessor: Yup.string().nullable(), // Optional field
  });
  const handleSaveData = async (values: any, shipmentId: string) => {
    let success = false;
    try {
      if (TE_ID) {
        const existingShipment = tableData?.find(
          (shipment) => shipment?.shipmentId === shipmentId
        );
        let payloadShipmentId: string | null = shipmentId;
        if (values?.tcShipmentNo !== existingShipment?.tcShipmentNo) {
          payloadShipmentId = null;
        }
        const payload = createPayload(values, TE_ID, payloadShipmentId);
        const result: any = await executePost(
          TCAppConfig.SHIPMENTS_ENDPOINT,
          payload
        );

        if (result.status === 200) {
          success = true;
          notify("Saved Successfully", "success");
          onNextTab();
          loadFormData();
          resetForm();
          toggleDrawer();
          setCopy(false);
        }
      } else {
        notify("TE_ID is not defined.", "error");
      }
    } catch (error: any) {
      console.log("error", error);
    } finally {
      return success;
    }
  };
  useEffect(() => {
    if (initialValues.consigneeCountryOrArea) {
      let countryCode = JSON.stringify(
        `[${[initialValues.consigneeCountryOrArea].map((item) => `'${item}'`)}]`
      ).replace(/^"|"$/g, "");
      getState(countryCode);
    }
  }, [initialValues.consigneeCountryOrArea]);

  useEffect(() => {
    if (initialValues.isConsigneeTeCertified === "N") {
      setDisable({
        disableConsigneeCountryOrArea: false,
        disableConsigneeStateorProvince: false,
        disableConsigneePostCode: false,
        disableConsigneeTown: false,
        disableConsigneeAddress1: false,
      });
    } 
  }, [initialValues.isConsigneeTeCertified]);

  const formConfig = {
    pageName: "shipments",
    initialValues: initialValues,
    validationSchema: shipmentConsigneeDetailValidationSchema,
    sections: [
      {
        title: "Add Shipment Details",
        fields: [
          {
            label: "Shipment No.",
            name: "tcShipmentNo",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: !getTCStandardGOTS ? true : false,
            value: initialValues.tcShipmentNo, // Set initial value here
            props: {
              placeholder: "Enter Shipment No.",
              variant: "outlined",
              fullWidth: true,
            },
          },
          {
            label: "Shipment Date",
            name: "tcShipmentDate",
            type: "date",
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: !getTCStandardGOTS ? true : false,
            events: {
              onChange: (value: any) => {
                Utills.cl("shipment date changed", value);
              },
            },
            value: initialValues.tcShipmentDate, // Set initial value here
            props: {
              placeholder: "Select TC Shipment Date",
              fullWidth: true,
            },
          },
          {
            label: "Shipment Doc No.",
            name: "tcShipmentDocNo",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: !getTCStandardGOTS ? true : false,
            value: initialValues.tcShipmentDocNo, // Set initial value here
            props: {
              placeholder: "Enter TC Shipment Doc No.",
              variant: "outlined",
              fullWidth: true,
              // helperText: 'Enter the shipment document number (optional)',
            },
          },
          {
            label: "Gross Shipping Weight (kg)", //Shipment Gross Shipping Weight renamed to match table hdr
            name: "tcShipmentGrossShippingWeight",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 6 },
            required: !getTCStandardGOTS ? true : false,
            value: initialValues.tcGrossShippingWeight, // Set initial value here
            props: {
              placeholder: "Enter Gross Shipping Weight",
              variant: "outlined",
              fullWidth: true,
              type: "number",
              // helperText: 'Enter the weight in kg',
            },
          },
          {
            // label: "Shipment Invoice References",
            label: "Invoice Reference No.", //Updating to match table header
            name: "tcShipmentInvoiceReferences",
            type: "chips",
            gridSize: { xs: 12, md: 12, lg: 12 },
            required: !getTCStandardGOTS ? true : false,
            value: initialValues.tcShipmentInvoiceReferences || [], // Set initial value here
            props: {
              placeholder: "Enter Invoice Reference No.",
              fullWidth: true,
            },
          },
        ],
      },
      {
        title: "Consignee Details",
        fields: [
          {
            label: "Does the consignee have a TE ID?",
            name: "isConsigneeTeCertified",
            type: "radio",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            value: initialValues.isConsigneeTeCertified,
            events: {
              onChange: (value: any) => {
                if (value === "Y") {
                  formRef.current.setFieldValue("consigneeTeId", "");
                  formRef.current.setFieldValue("consigneeName", "");
                  formRef.current.setFieldValue("consigneeAddress1", "");
                  formRef.current.setFieldValue("consigneeAddress2", "");
                  formRef.current.setFieldValue("consigneeAddress3", "");
                  formRef.current.setFieldValue("consigneeTown", "");
                  formRef.current.setFieldValue("consigneePostcode", "");
                  formRef.current.setFieldValue("consigneeCountryOrArea", "");
                  formRef.current.setFieldValue("consigneeStateOrProvince", "");
                  setDisable((prev) => ({
                    ...prev,
                    disableConsigneeCountryOrArea: true,
                    disableConsigneeStateorProvince: true,
                    disableConsigneePostCode: true,
                    disableConsigneeTown: true,
                    disableConsigneeAddress1: true,
                  }));
                } else {
                  formRef.current.setFieldValue("consigneeTeId", "");
                  formRef.current.setFieldValue("consigneeName", "");
                  formRef.current.setFieldValue("consigneeAddress1", "");
                  formRef.current.setFieldValue("consigneeAddress2", "");
                  formRef.current.setFieldValue("consigneeAddress3", "");
                  formRef.current.setFieldValue("consigneeTown", "");
                  formRef.current.setFieldValue("consigneePostcode", "");
                  formRef.current.setFieldValue("consigneeCountryOrArea", "");
                  formRef.current.setFieldValue("consigneeStateOrProvince", "");
                  setDisable((prev) => ({
                    ...prev,
                    disableConsigneeCountryOrArea: false,
                    disableConsigneeStateorProvince: false,
                    disableConsigneePostCode: false,
                    disableConsigneeTown: false,
                    disableConsigneeAddress1: false,
                  }));
                }
              },
            },
            props: {
              options: [
                { value: "Y", label: "Yes" },
                { value: "N", label: "No" },
              ],
            },
          },
          // {
          //   label: 'Consignee TE-ID',
          //   name: 'consigneeTeId',
          //   type: 'text',
          //   gridSize: { xs: 12, md: 6, lg: 4 },
          //   required: true,
          //   value: initialValues.consigneeTeId, // Set initial value here
          //   condition: (values: Record<string, any>) => values.isConsigneeTeCertified === 'yes',
          //   props: {
          //     placeholder: 'Enter Consignee TE-ID',
          //     variant: 'outlined',
          //     fullWidth: true,
          // helperText: 'Enter the Consignee TE-ID (optional)',
          //   },
          // },
          {
            label: "Consignee TE-ID",
            name: "consigneeTeId",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: false,
            value: initialValues.consigneeTeId,
            visible: (values: any) => values.isConsigneeTeCertified === "Y",
            props: {
              pageName: "shipments",
              placeholder: "Search Buyer",
              variant: "outlined",
              restrictInputFormat: isTEEnabled,
              onChange: handleConsigneeTEIdValueChange,
              displayKey: "TE_ID",
              onSearch: (query: string, offset: number) => {
                const response = fetchTEDetallsFromAPI(query, offset, "query");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "Consignee TE-ID",
            name: "consigneeTeId",
            type: "text",
            gridSize: { xs: 12, md: 4 },
            required: false,
            value: initialValues.consigneeTeId,
            visible: (values: any) => values.isConsigneeTeCertified === "N",
            props: {
              placeholder: "Enter Consignee TE-ID",
              variant: "outlined",
              fullWidth: true,
              // helperText: 'Enter the Consignee Name',
            },
          },
          {
            label: "Name",
            name: "consigneeName",
            type: "search",
            gridSize: { xs: 12, md: 4 },
            required: false,
            value: initialValues.consigneeName,
            visible: (values: any) => values.isConsigneeTeCertified === "Y",
            props: {
              pageName: "shipments",
              placeholder: "Search consignee Name",
              variant: "outlined",
              onChange: handleConsigneeNameValueChange,
              displayKey: "account_name",
              onSearch: (query: string, offset: number) => {
                const response = fetchTEDetallsFromAPI(query, offset, "name");
                return response;
              },
              fullWidth: true,
            },
          },
          {
            label: "Name",
            name: "consigneeName",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            value: initialValues.consigneeName, // Set initial value here
            visible: (values: any) => values.isConsigneeTeCertified === "N",
            props: {
              placeholder: "Enter Consignee Name",
              variant: "outlined",
              fullWidth: true,
            },
          },
          {
            label: "Consignee Address",
            name: "consigneeAddress1",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            value: initialValues.consigneeAddress1,
            disabled: (values: any) => disable.disableConsigneeAddress1,
            props: {
              placeholder: "Enter Consignee Address",
              variant: "outlined",
              fullWidth: true,
              // helperText: 'Enter the first line of the address',
            },
          },
          // {
          //   label: "Consignee Address 2",
          //   name: "consigneeAddress2",
          //   type: "text",
          //   gridSize: { xs: 12, md: 6, lg: 4 },
          //   required: false,
          //   value: initialValues.consigneeAddress2, // Set initial value here
          //   disabled: (values: any) => values.isConsigneeTeCertified === "Y",
          //   props: {
          //     placeholder: "Enter Consignee Address 2",
          //     variant: "outlined",
          //     fullWidth: true,
          //     // helperText: 'Enter the second line of the address (optional)',
          //   },
          // },
          // {
          //   label: "Consignee Address 3",
          //   name: "consigneeAddress3",
          //   type: "text",
          //   gridSize: { xs: 12, md: 6, lg: 4 },
          //   required: false,
          //   value: initialValues.consigneeAddress3, // Set initial value here
          //   disabled: (values: any) => values.isConsigneeTeCertified === "Y",
          //   props: {
          //     placeholder: "Enter Consignee Address 3",
          //     variant: "outlined",
          //     fullWidth: true,
          //     // helperText: 'Enter the third line of the address (optional)',
          //   },
          // },
          {
            label: "Consignee Town",
            name: "consigneeTown",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            value: initialValues.consigneeTown, // Set initial value here
            disabled: (values: any) => {
              if (!disable.disableConsigneeTown) {
                return false;
              }
              return values.isConsigneeTeCertified === "Y";
            },
            props: {
              placeholder: "Enter Consignee Town",
              variant: "outlined",
              fullWidth: true,
              // helperText: 'Enter the consigneeTown or city',
            },
          },
          {
            label: "Postcode",
            name: "consigneePostcode",
            type: "text",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            value: initialValues.consigneePostcode, // Set initial value here
            disabled: (values: any) => {
              if (!disable.disableConsigneePostCode) {
                return false;
              }
              return values.isConsigneeTeCertified === "Y";
            },
            props: {
              placeholder: "Enter Postcode",
              variant: "outlined",
              fullWidth: true,
              // helperText: 'Enter the postal code',
            },
          },
          {
            label: "Consignee Country/Area",
            name: "consigneeCountryOrArea",
            type: "select",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            value: initialValues.consigneeCountryOrArea, // Set initial value here
            disabled: (values: any) => disable.disableConsigneeCountryOrArea,
            events: {
              onChange: (newValue: any, updatedValues: any) => {
                let countryCode = JSON.stringify(
                  `[${[newValue].map((item) => `'${item}'`)}]`
                ).replace(/^"|"$/g, "");
                getState(countryCode);
                Utills.cl("Updated form values:", updatedValues);
              },
            },
            props: {
              enableSearch: true,
              options: countries,
              placeholder: "Select Consignee Country/Area",
              fullWidth: true,
            },
          },
          // {
          //   label: 'Consignee Country/Area',
          //   name: 'consigneeCountryOrArea',
          //   type: 'text',
          //   gridSize: { xs: 12, md: 6, lg: 4 },
          //   required: false,
          //   value: initialValues.consigneeCountryOrArea, // Set initial value here
          //   disabled: (values: any) => values.isConsigneeTeCertified === 'Y',
          //   visible: (values: any) => values.isConsigneeTeCertified === 'Y',
          //   props: {
          //     placeholder: 'Enter Consignee Country/Area',
          //     variant: 'outlined',
          //     fullWidth: true,
          //   },
          // },
          {
            label: "Consignee State/Province",
            name: "consigneeStateOrProvince",
            type: "select",
            gridSize: { xs: 12, md: 6, lg: 4 },
            required: false,
            value: initialValues.consigneeStateOrProvince, // Set initial value here
            disabled: (values: any) => disable.disableConsigneeStateorProvince,
            events: {
              onChange: (newValue: any, updatedValues: any) => {
                Utills.cl("Field changed:", newValue);
              },
            },
            props: {
              enableSearch: true,
              options: states,
              placeholder: "Select Consignee State/Province",
              fullWidth: true,
            },
          },
          // {
          //   label: 'Consignee State/Province',
          //   name: 'consigneeStateOrProvince',
          //   type: 'text',
          //   gridSize: { xs: 12, md: 6, lg: 4 },
          //   required: false,
          //   value: initialValues.consigneeStateOrProvince, // Set initial value here
          //   disabled: (values: any) => values.isConsigneeTeCertified === 'Y',
          //   visible: (values: any) => values.isConsigneeTeCertified === 'Y',
          //   props: {
          //     placeholder: 'Enter Consignee State/Province',
          //     variant: 'outlined',
          //     fullWidth: true,
          //   },
          // },
        ],
      },
    ],
    handleSubmit: async (values: any) => {
      if (isViewOnly) {
        toggleDrawer();
        return;
      }
      
      if (selectedShipmentId && values.shipmentId) {
        // Find the shipment in the table data that matches the provided shipmentId
        const existingShipment = tableData.find(
          (item) => item.shipmentId === values.shipmentId
        );
        // If the shipment exists, check if its shipment number has changed
        if (existingShipment && !getCopy) {
          if (existingShipment.tcShipmentNo !== values.tcShipmentNo) {
            const row = {
              original: {
                tcShipmentNo: existingShipment.tcShipmentNo,
                shipmentId: values.shipmentId,
              },
            };

            // Store the values to save after deletion completes
            setPendingSave(values);
            setOriginalValue(existingShipment.tcShipmentNo);
            await handleEditDelete(row);
            // Don't call handleSaveData here - it will be called in handleConfirmSave
          } else {
            handleSaveData(values, values.shipmentId);
          }
        } else {
          handleSaveData(values, getCopy ? "" : values.shipmentId);
        }
      } else {
        handleSaveData(values, values.shipmentId);
      }
    },
  };

  const handleEdit = (row: any) => {
    setCopy(false);
    const value = row?.original as ApiShipmentResponseItem;
    setSelectedShipmentId(value.shipmentId);
    if (TE_ID)
      fetchShipmentDetails(executeAdditionalGet, TE_ID, value.shipmentId)
        .then((data) => {
          if (data?.data) {
            // console.log(`Shipment Details Fetched Successfully ${JSON.stringify(data?.data)}`);

            const { shipmentId, tcShipmentConsigneeDetails } = data.data;
            if (
              tcShipmentConsigneeDetails &&
              tcShipmentConsigneeDetails.length > 0
            ) {
              const initialData = {
                ...tcShipmentConsigneeDetails[0],
                shipmentId,
              };
              console.log(initialData);

              if (tcShipmentConsigneeDetails?.[0]?.consigneePostcode) {
                setDisable((prev) => ({
                  ...prev,
                  disableConsigneePostCode: true,
                }));
              } else {
                setDisable((prev) => ({
                  ...prev,
                  disableConsigneePostCode: false,
                }));
              }
              setInitialValues(initialData);
            }
          }
          toggleDrawer();
        })
        .catch((err) => notify(err.message, "error"));
  };

  const handleDelete = (row: any) => {
    // TO DO Port Changes
    const tcShipmentNo = row?.original?.tcShipmentNo;
    const shipmentId = row?.original?.shipmentId;
    setTcShipmentNo(tcShipmentNo);
    setSelectedShipmentId(shipmentId);
    setDialogOpen(true);
    setPopUpBtnName("Delete");
    setPopUpTitle("Confirm Delete ?");
    setPopUpMessage(
      `Deleting Shipment ${tcShipmentNo} will remove all the Associated Records, are you sure want to delete it`
    );
  };
  const handleEditDelete = (row: any) => {
    // TO DO Port Changes
    const tcShipmentNo = row?.original?.tcShipmentNo;
    const shipmentId = row?.original?.shipmentId;
    setTcShipmentNo(tcShipmentNo);
    setSelectedShipmentId(shipmentId);
    setDialogOpen(true);
    setPopUpBtnName("Save");
    setPopUpTitle("Confirm Save");
    setPopUpMessage(
      `Editing ShipmentNo ${tcShipmentNo} will remove all the Associated Records, are you sure want to edit it`
    );
  };
  const handleCopy = (row: any) => {
    setCopy(true);
    const value = row?.original as ApiShipmentResponseItem;
    setSelectedShipmentId(value.shipmentId);
    console.log(value);
    if (TE_ID)
      fetchShipmentDetails(executeAdditionalGet, TE_ID, value.shipmentId)
        .then((data) => {
          if (data?.data) {
            const { shipmentId, tcShipmentConsigneeDetails } = data.data;
            if (
              tcShipmentConsigneeDetails &&
              tcShipmentConsigneeDetails.length > 0
            ) {
              const initialData = {
                ...tcShipmentConsigneeDetails[0],
                shipmentId,
              };
              setInitialValues(initialData);
            }
          }
          toggleDrawer();
        })
        .catch((err) => notify(err.message, "error"));
  };

  const mapDataToRequest = (data: any, tcid: any, type?: string) => {
    const totalWeight = data.reduce(
      (sum: any, item: any) => sum + parseFloat(item.tcGrossShippingWeight),
      0
    );
    return {
      tcId: tcid,
      tcGrossShippingWeight: parseFloat(totalWeight),
      isPostCreation: type === "create" ? "Yes" : "No",
      tcShipmentConsigneeDetails: data.map((shipment: any, index: any) => ({
        tcShipmentConsigneeOrder: (index + 1).toString(), // Assuming order starts from 1
        tcShipmentNo: shipment.tcShipmentNo,
        tcShipmentDate: shipment.tcShipmentDate,
        tcShipmentDocNo: shipment.tcShipmentDocNo,
        tcShipmentGrossShippingWeight: shipment.tcGrossShippingWeight,
        tcShipmentInvoiceReferences: shipment.tcShipmentInvoiceReferences,
        consigneeName: shipment.consigneeName || "",
        consigneeTeId: shipment.consigneeTeId || "",
        isConsigneeTeCertified: shipment.isConsigneeTeCertified, // Assuming all consignees are certified
        consigneeAddress1: shipment.consigneeAddress1 || "",
        consigneeAddress2: shipment.consigneeAddress2 || "",
        consigneeAddress3: shipment.consigneeAddress3 || "",
        consigneePostcode: shipment.consigneePostcode || "",
        consigneeTown: shipment.consigneeTown || "",
        consigneeStateOrProvince: shipment.consigneeStateOrProvince || "",
        consigneeCountryOrArea: shipment.consigneeCountryOrArea || "",
        consigneeCountryOrAreaDescription: shipment.consigneeCountryOrArea
          ? useTransactionCertificateStore
              .getState()
              .getCountryCodes.find(
                (option: any) =>
                  option.value === shipment.consigneeCountryOrArea
              )?.label || ""
          : "",

        consigneeStateOrProvinceDescription: shipment.consigneeStateOrProvince
          ? useTransactionCertificateStore
              .getState()
              .getStates.find(
                (option: any) =>
                  option.value === shipment.consigneeStateOrProvince
              )?.label || ""
          : "",
      })),
    };
  };

  const handleDeleteSaveData = async () => {
    // Perform API call to save form data here
    try {
      if (TE_ID) {
        if (!isDeleteOnly && getDeleteSave()) {
          const userFilledValues = getCurrentFormValues();
          updateTableRowbyIndex(getEditRowIndex, userFilledValues);
        } else if (isDeleteOnly && !getDeleteSave()) {
          removeTableRowbyIndex(getEditRowIndex);
          const deletedData = data.filter((item, index) => {
            index !== getEditRowIndex;
          });
          setData(deletedData);
          setEditRowIndex(-1);
        }
        const shipmentsDatas = getCurrentTableData();
        setDeleteOnly(false);
        setDeleteSave(false);
        setEditSave(false);
        const payload = mapDataToRequest(shipmentsDatas, TE_ID);
        Utills.cl("Form Payload:", JSON.stringify(payload));

        const result: any = await executePost(
          TCAppConfig.SHIPMENTS_ENDPOINT,
          payload
        );
        if (result.status == 200) {
          notify("Saved Succesfully", "success");

          if (!isDeleteOnly) toggleDrawer();

          replaceTableDatas([]);
          await loadFormData();
        } else {
          notify("Unable to Save", "error");
        }
      }
    } catch (error) {
      setNewDataTCSaved(false);
      setLoadingState(false);
      console.error("Error saving Transaction Certificate:", error);
    }
  };
  const onNext = async () => {
    // alert(`testtt ${JSON.stringify(initialValues)}`);
    if (isViewOnly) {
      navigate(`/tc/${formtype}/certified-products-components/${TE_ID}`);
      return;
    }
    
    if (getTCStandardGOTS && tableData.length == 0) {
      const gotsPayload = {
        tcId: "",
        tcShipmentGrossShippingWeight: 0,
        tcShipmentNo: "1",
        tcShipmentConsigneeDetails: [
          {
            tcShipmentDate: "",
            tcShipmentDocNo: "",
            tcShipmentGrossShippingWeight: 0,
            tcShipmentInvoiceReferences: [],
            consigneeName: "",
            consigneeTeId: "",
            consigneeAddress1: "",
            consigneePostcode: "",
            consigneeTown: "",
            consigneeStateOrProvince: "",
            consigneeCountryOrArea: "",
            isConsigneeTeCertified: "",
          },
        ],
      };
      await handleSaveData(gotsPayload, "");
    }
    navigate(`/tc/${formtype}/certified-products-components/${TE_ID}`);
  };
  const onBack = () => {
    navigate(`/tc/${formtype}/seller-buyer-products/${TE_ID}`);
  };
  // const saveData = async () => {
  //   // Perform API call to save form data here
  //   try {
  //     // setLoadingState(true)
  //     // removeTableRowbyIndex(0)
  //     const shipmentsDatas = getCurrentTableData()
  //     const payload = mapDataToRequest(shipmentsDatas, TE_ID, 'create')
  //     Utills.cl("Form Payload:", JSON.stringify(payload));

  //     const result: any = await executePost(TCAppConfig.SHIPMENTS_ENDPOINT, payload)
  //     // await transactionCertificateService.saveShipMents(payload)
  //     // Utills.cl(`response handle submit ${result}`)
  //     if (result.status == 200) {
  //       notify("Saved Succesfully", "success")
  //       // navigate(`/tc/${formtype}/certified-products-components/${TE_ID}`);
  //       loadFormData();
  //     }
  //     else {
  //       notify("Unable to Save", "error")
  //     }
  //   }
  //   catch (error) {
  //     setNewDataTCSaved(false)
  //     setLoadingState(false)
  //     console.error("Error saving Transaction Certificate:", error);
  //   }
  // };
  return (
    <>
      {loading ? (
        <LoaderComponent />
      ) : (
        <>
          {/* <Box component="main" sx={{ flexGrow: 1, p: 1, my: 4 }}></Box> */}
          <Box
            display="flex"
            mb={3}
            justifyContent="space-between"
            width="100%"
          >
            <span>
              Gross Shipping Weight:{" "}
              {tableData.length > 0
                ? tableData.reduce(
                    (sum: number, item: any) =>
                      sum + parseFloat(item.tcGrossShippingWeight),
                    0
                  )
                : 0}{" "}
              kg
            </span>
            {!hasSubmitTC && !isViewOnly && (
              <StyledButton
                variant="contained"
                onClick={toggleDrawer}
                sx={{ boxShadow: "none" }}
              >
                Add Shipment
              </StyledButton>
            )}
          </Box>
          <ModalPopup
            open={drawerOpen}
            onClose={toggleDrawer}
            onSave={!isViewOnly && !hasSubmitTC ? handleSubmit : undefined}
          >
            <FormBuilder formConfig={formConfig} formRef={formRef} />
          </ModalPopup>
          <CustomTable
            columns={columns}
            data={tableData}
            paginations={pagination}
            setPaginations={setPagination}
            rowCount={rowCount}
            enableTopToolbar={false}
            enableBottomToolbar={true}
            enableRowActions={!hasSubmitTC}
            renderDetailPanel={({ row }) =>
              // Only mount the detail panel if the row is expanded
              row.getIsExpanded() ? (
                <RenderDetailPanel row={row} />
              ) : (
                <>NO data</>
              )
            }
            renderRowActions={({ row }) => (
              <ActionsMenu
                onEdit={() => handleEdit(row)}
                onDelete={!isViewOnly ? () => handleDelete(row) : undefined}
                onCopy={!isViewOnly ? () => handleCopy(row) : undefined}
                row={row}
              />
            )}
          />
          {!drawerOpen ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
                gap: "0.5rem",
              }}
            >
              <NavLink to="/tc-dashboard">
                <InnerButton>Home</InnerButton>
              </NavLink>
              {tableData.length > 0 && (
                <InnerButton onClick={onNext}>Next</InnerButton>
              )}
            </Box>
          ) : hasSubmitTC || getTCStandardGOTS ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
                gap: "0.5rem",
              }}
            >
              <InnerButton onClick={onBack}>Back</InnerButton>
              <InnerButton onClick={onNext}>
                {isViewOnly ? "Next" : getTCStandardGOTS ? "Save & Next" : "Next"}
              </InnerButton>
            </Box>
          ) : (
            <></>
          )}

          {/* TO DO Port Changes */}
          <AlertPopup
            open={dialogOpen}
            title={popUpTitle}
            message={popUpMessage}
            onClose={handleCancelSave}
            onConfirm={handleConfirmSave}
            confirmText={popUpBtnName}
            cancelText="Cancel"
          />
        </>
      )}
    </>
  );
};

export default Shipments;
